export const filterOption = (input: any, option: any) => { 
    return (option!.children as unknown as string).includes(input) 
}

export const filterOptionSort = (optionA: any, optionB: any) => {
    return (optionA!.children as unknown as string)
            .toLowerCase()
            .localeCompare((optionB!.children as unknown as string).toLowerCase())
}